// these metrics are broken and were broken for quite a while
// todo: fix
// affected metrics as well GCPAppVisitedFromBackofficeDashboard and GCPAppVisitedFromGCPRequestEmail

export const METRICS_CSV_DOWNLOAD_LOGGED = "METRICS_CSV_DOWNLOAD_LOGGED";
export const logCSVDownloaded = (): IAction<null> => ({
  type: METRICS_CSV_DOWNLOAD_LOGGED,
  payload: null,
});

export const METRICS_GPX_DOWNLOAD_LOGGED = "METRICS_GPX_DOWNLOAD_LOGGED";
export const logGPXDownloaded = (): IAction<null> => ({
  type: METRICS_GPX_DOWNLOAD_LOGGED,
  payload: null,
});
